import { makeRequest } from "../helpers/makeRequest";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

import {
  messageUpdateUrl,
  messagesForTicketUrl,
  messagesForOrderUrl,
  messagesForTicketIcludeOrdersUrl,
  equipmentMessageUpdateUrl,
  equipmentMessagesForEquipmentUrl,
} from "../helpers/apiUrls";
import { prepareUrlWithQueryParams } from "../helpers/methods";

export default function useCommunicationService() {
  const axiosPrivate = useAxiosPrivate();

  const getMessagesForItemData = (
    itemId,
    searchParams = {},
    itemType = "ticket"
  ) => {
    if (itemType === "ticket")
      return getMessagesForTicketInludesOrdersData(itemId, searchParams);
    if (itemType === "order")
      return getMessagesForOrderData(itemId, searchParams);
    if (itemType === "ticket_order")
      return getMessagesForTicketInludesOrdersData(itemId, searchParams);
    if (itemType === "equipment")
      return getMessagesForEquipmentData(itemId, searchParams);
    return Promise.resolve([]);
  };

  const getMessagesForOrderData = (orderId, searchParams = {}) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(messagesForOrderUrl(orderId), searchParams)
    );
  };

  const getMessagesForTicketInludesOrdersData = (
    ticketId,
    searchParams = {}
  ) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(
        messagesForTicketIcludeOrdersUrl(ticketId),
        searchParams
      )
    );
  };

  const getMessagesForEquipmentData = (equipmentId, searchParams = {}) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(
        equipmentMessagesForEquipmentUrl(equipmentId),
        searchParams
      )
    );
  };

  const sendNewMessageInItem = (itemId, newMessage, itemType) => {
    if (itemType === "ticket" || itemType === "ticket_order")
      return sendNewMessageInTicket(itemId, newMessage);
    if (itemType === "order") return sendNewMessageInOrder(itemId, newMessage);
    if (itemType === "equipment")
      return sendNewMessageInEquipment(itemId, newMessage);
    return null;
  };

  const sendNewMessageInTicket = (ticketId, newMessage) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(messagesForTicketUrl(ticketId)),
      {
        method: "POST",
        data: newMessage,
      }
    );
  };

  const sendNewMessageInOrder = (orderId, newMessage) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(messagesForOrderUrl(orderId)),
      {
        method: "POST",
        data: newMessage,
      }
    );
  };

  const sendNewMessageInEquipment = (equipmentId, newMessage) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(equipmentMessagesForEquipmentUrl(equipmentId)),
      {
        method: "POST",
        data: newMessage,
      }
    );
  };

  const udpateMessageData = (messageId, message, itemType = "ticket") => {
    const updateUrl =
      itemType === "equipment" ? equipmentMessageUpdateUrl : messageUpdateUrl;
    return makeRequest(axiosPrivate, updateUrl(messageId), {
      method: "PATCH",
      data: message,
    });
  };

  return {
    getMessagesForItemData,
    sendNewMessageInItem,
    sendNewMessageInTicket,
    udpateMessageData,
  };
}
